import { render, staticRenderFns } from "./ModuleSelectMenuItem.vue?vue&type=template&id=00d54c4a"
import script from "./ModuleSelectMenuItem.vue?vue&type=script&lang=js"
export * from "./ModuleSelectMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports